import { Box, Button, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import Flex from '@Components/Bases/Flex';
import ChangeYearModal from '@Components/Modal/ChangeYearModal';
import {
  IDraftReport,
  useSaveDraftReportStatus,
} from '@Domains/ReviewSummaryReport';
import { useDisclosure } from '@hooks/useDisclosure';
import { convertBuddhistYearToGregorian } from '@Utils/datetime';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { SectionEnum } from 'src/Enum/SectionEnum';
import { useReviewSummaryReportForm } from './ReviewSummaryReportFormProvider/ReviewSummaryReportFormProvider';

const ReviewReport = () => {
  const { id } = useParams();
  const [, saveReviewDraftReport] = useSaveDraftReportStatus(id);
  const { setValue, watch } = useReviewSummaryReportForm();
  const { refetchProgressWithUpdate, progressData, breadcrumbs } =
    useProgressBar();
  const navigate = useNavigate();

  const [isDialogOpen, { open: openDialog, close: closeDialog }] =
    useDisclosure();

  const isDraftReport = watch('draftReportStatus');
  const publishedDate = watch('publishedDate');

  const isPublished = Boolean(publishedDate);

  const startOperatingYear = convertBuddhistYearToGregorian(
    progressData?.report?.startOperatingYear
  );
  const currentYear = new Date().getFullYear();

  const handleSaveReviewDraftReport = async () => {
    const url = `/report/${id}/preview?section=${SectionEnum.Summary}`;

    if (!isDraftReport) {
      try {
        const response = await saveReviewDraftReport({
          data: { isDraftReport: true } as IDraftReport,
        });

        if (response) {
          setValue('draftReportStatus', response.data.isDraftReport);
          refetchProgressWithUpdate(false);
        }
      } catch (error) {
        console.error(error);
      }
    }

    window.open(url, '_blank');
  };

  const handleRedirectToLandingPage = () => {
    navigate(`/?report=${breadcrumbs?.reportId}`);
  };

  const handleCreateReviewDraftReport = () => {
    if (currentYear !== startOperatingYear) {
      openDialog();
    } else {
      handleSaveReviewDraftReport();
    }
  };

  return (
    <Box bgcolor={'white'} p={2}>
      <Typography fontWeight={800}>ตรวจสอบรายงาน Corporate Value Up</Typography>
      <Typography mt={2}>
        คลิกสร้างรายงานฉบับร่าง เพื่อเข้าดูรายงาน Corporate Value Up
      </Typography>
      <Flex width={1} mt={2} justifyContent={'center'}>
        <Button onClick={handleCreateReviewDraftReport} disabled={isPublished}>
          สร้างรายงานฉบับร่าง
        </Button>
      </Flex>
      <ChangeYearModal
        opened={isDialogOpen}
        close={closeDialog}
        confirm={handleRedirectToLandingPage}
      />
    </Box>
  );
};

export default ReviewReport;
